import React from 'react';
import si from 'si';
import {TextField} from '../FormFields/formFields';
import ReceiptActions from './ReceiptActions';
import ReceiptStore from './ReceiptStore';
import GuestOrderSummary from './GuestOrderSummary';


export default class FindMyReceipt extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.state = ReceiptStore.getState();
    }

    componentDidMount() {
        ReceiptStore.listen(this.onChange);

        var session =
            typeof window !== "undefined" ? window.sessionStorage : null;            
        let orderId = session.getItem("orderNum");
        session.setItem("orderNum",null);

        if(orderId !== null && orderId !== "null") {
            ReceiptActions.getGuestOrderById(orderId);     
        }
        console.log(window.document.referrer);
    }

    componentWillUnmount() {
        ReceiptStore.unlisten(this.onChange);
    }

    onChange(state) {
        this.setState(state);
    }

	registerErrors() {
		this.refs.orderCode.registerErrors();
		this.refs.emailAddress.registerErrors();
	}

	canSubmit() {
		return (
			this.refs.orderCode.isValid()
			&& this.refs.emailAddress.isValid()
		);
	}

	submitSearch(){
		let sendData = {
			OrderNumber: this.state.orderCode,
			EmailAddress: this.state.emailAddress
		}
		if(!this.canSubmit()){
			this.registerErrors();
			return false;
		}
        ReceiptActions.getGuestOrderDetail(this.state.orderCode, this.state.emailAddress);
	}



    render() {
		let Rules = {
			OrderNum: { required: true, requiredMessage: this.props.resources['PWS.Globals.Required'] },
			EmailAddress: { required: true, requiredMessage: this.props.resources['PWS.Globals.Required'], email: true, emailMessage: 'Invalid Email Address' }
		}
        return (
            Object.keys(this.state.Details).length === 0 ?
            <div className="guest-receipt find findreceipt-form-area">
                <div className="animate-in">
                    {this.state.hasError && <div className="login-error-message">{this.props.resources["PWS.GuestCheckout.OrderNotFound"]}</div> }
                    <form id="findreceipt-form" method="post">
					<div className="basic-title buffer-bottom">{this.props.resources["PWS.GuestCheckout.EnterOrderDetails"]}</div>
                    <TextField
                            ref="orderCode"
                            name="orderCode"
                            classes="input-100"
                            handleChange={ReceiptActions.changeField}
                            label="Order Number"
                            value={this.state.orderCode}
                            Rules={Rules.OrderNum}
                        />
                    <TextField
                            ref="emailAddress"
                            name="emailAddress"
                            classes="input-100"
                            handleChange={ReceiptActions.changeField}
                            label="E-mail Address"
                            value={this.state.emailAddress}
                            Rules={Rules.EmailAddress}
                        />
					<button type="button" id="login-form-button" className="basic-submit-button" onClick={this.submitSearch.bind(this)}>Find Order</button>
                    </form>
                </div>
            </div> :
            <GuestOrderSummary resources={this.props.resources} Details={this.state.Details}/>

                     
        )};
}


// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/GuestCheckout/FindMyReceipt.js